import { Edit3, Trash2 } from "lucide-react";

var STATUS_LABELS = { ativo: "Ativo", cancelado: "Cancelado", contemplado: "Contemplado", em_atraso: "Em Atraso" };
var STATUS_COLORS = {
  ativo: "bg-emerald-100 text-emerald-700", cancelado: "bg-red-100 text-red-700",
  contemplado: "bg-blue-100 text-blue-700", em_atraso: "bg-amber-100 text-amber-700",
};

function formatCurrency(v) {
  if (v == null || v === 0) return "-";
  return "R$ " + Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function ConsortiumsTable({ items, isAdmin, onEdit, onDelete }) {
  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-100 bg-gray-50/50">
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Grupo</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Cota</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Administradora</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Valor Carta</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Parcela</th>
            <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="text-right py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">Acoes</th>
          </tr>
        </thead>
        <tbody>
          {items.map(function(item) {
            return (
              <tr key={item.id} className="border-b border-gray-50 hover:bg-[#3B82F6]/[0.02]" data-testid={"consortium-row-" + item.id}>
                <td className="py-3 px-4">
                  <p className="text-sm font-medium text-[#0A2F3D]">{item.client_name}</p>
                  <p className="text-xs text-gray-400">{item.client_email}</p>
                </td>
                <td className="py-3 px-4"><span className="px-2.5 py-1 text-xs font-bold rounded-lg bg-[#F26A4B]/10 text-[#F26A4B]">{item.grupo || "-"}</span></td>
                <td className="py-3 px-4"><span className="px-2.5 py-1 text-xs font-bold rounded-lg bg-[#3B82F6]/10 text-[#3B82F6]">{item.cota || "-"}</span></td>
                <td className="py-3 px-4 text-sm text-gray-600">{item.administrator || "-"}</td>
                <td className="py-3 px-4 text-sm font-medium text-[#0A2F3D]">{formatCurrency(item.value)}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{formatCurrency(item.installment_value)}/mes</td>
                <td className="py-3 px-4">
                  <span className={"px-2.5 py-1 text-xs font-medium rounded-full " + (STATUS_COLORS[item.status] || "bg-gray-100 text-gray-700")}>
                    {STATUS_LABELS[item.status] || item.status}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center justify-end gap-1">
                    <button onClick={function() { onEdit(item); }} className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-400 hover:text-[#3B82F6]" data-testid={"consortium-edit-" + item.id}><Edit3 className="w-4 h-4" /></button>
                    {isAdmin && <button onClick={function() { onDelete(item); }} className="p-1.5 hover:bg-red-50 rounded-lg text-gray-400 hover:text-red-500" data-testid={"consortium-delete-" + item.id}><Trash2 className="w-4 h-4" /></button>}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export function ConsortiumsMobile({ items, isAdmin, onEdit, onDelete }) {
  return (
    <div className="md:hidden divide-y divide-gray-50">
      {items.map(function(item) {
        return (
          <div key={item.id} className="p-4" data-testid={"consortium-card-" + item.id}>
            <div className="flex items-start justify-between mb-2">
              <div>
                <p className="text-sm font-semibold text-[#0A2F3D]">{item.client_name}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="px-2 py-0.5 text-xs font-bold rounded bg-[#F26A4B]/10 text-[#F26A4B]">G: {item.grupo || "-"}</span>
                  <span className="px-2 py-0.5 text-xs font-bold rounded bg-[#3B82F6]/10 text-[#3B82F6]">C: {item.cota || "-"}</span>
                </div>
              </div>
              <span className={"px-2 py-1 text-xs font-medium rounded-full " + (STATUS_COLORS[item.status] || "bg-gray-100 text-gray-700")}>
                {STATUS_LABELS[item.status] || item.status}
              </span>
            </div>
            <div className="flex items-center justify-between mt-2">
              <span className="text-xs text-gray-400">{item.administrator || "-"} | {formatCurrency(item.value)}</span>
              <div className="flex gap-1">
                <button onClick={function() { onEdit(item); }} className="p-1.5 hover:bg-gray-100 rounded-lg text-gray-400"><Edit3 className="w-4 h-4" /></button>
                {isAdmin && <button onClick={function() { onDelete(item); }} className="p-1.5 hover:bg-red-50 rounded-lg text-gray-400"><Trash2 className="w-4 h-4" /></button>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
